import styled, { css } from 'styled-components'
import { accessibilityZIndex, device } from '../../../styles/GlobalVariables'

interface IVerticalPlayerViewWrapperProps {
  showPlayer?: boolean | undefined
  onTouchStart?: (e: React.TouchEvent<HTMLDivElement>) => void
}

export const PlayerViewContainer = styled.div<IVerticalPlayerViewWrapperProps>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 1);
  z-index: ${accessibilityZIndex + 1};
  justify-content: center;
  align-items: center;
  padding: 0;
  direction: ltr;

  /* focus is moved here when the player opens; the frame would ring the screen */
  &:focus {
    outline: none;
  }

  ${device.medium} {
    direction: rtl;
    display: ${props => (props.showPlayer ? 'flex' : 'none')};
    background-color: rgba(0, 0, 0, 0.95);
    padding: 3px;
  }

  //pointer-events: none;
  //touch-action: none;
  //overflow: hidden;
`

export const PlayerViewClose = styled.div`
  position: absolute;
  top: 83px;
  right: 4vw;
  width: 32px;
  height: 32px;
  z-index: 22;
  cursor: pointer;
`
export const PlayerViewWrapper = styled.div<{ isMiniSeries: boolean }>`
  position: relative;
  height: 100%;
  display: flex;
  gap: 20px;
  justify-content: space-between;

  ${device.medium} {
    flex-direction: row;
    max-height: 80vh;
    min-height: 80vh;
    align-items: center;
  }

  .swiper {
    height: 100%;
    width: 100%;

    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      ${device.medium} {
        height: 100%;
        gap: 100px;
      }
    }
  }
`

export const ReelsSlideMount = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  ${device.medium} {
    width: auto;
    aspect-ratio: 9 / 16;
    flex-shrink: 0;
  }
`

export const ReelsSlideMountImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.4;
  pointer-events: none;
`
export const PlayerViewSwiperButtonContainer = styled.div`
  flex-direction: column;
  gap: 20px;
  display: none;

  ${device.small} {
    display: flex;
  }
`
export const PlayerViewSwiperButton = styled.button<{
  reverse?: boolean
  enabled: boolean
}>`
  cursor: pointer;
  flex-shrink: 0;
  ${props =>
    props.reverse &&
    css`
      svg {
        transform: matrix(-1, 0, 0, 1, 0, 0);
      }
    `};
  background-color: transparent;
  border: none;
  display: none;

  /* from the same width as their column (768), not 1280: an iPad in landscape
     or a small laptop had an empty column and no way to the next clip */
  ${device.small} {
    display: flex;
    opacity: 0.3;
    pointer-events: none;
    ${props =>
      props.enabled &&
      css`
        opacity: 1;
        pointer-events: auto;
      `}
  }
`
export const PlayerViewSwiperPlaceHolder = styled.div`
  height: 100dvh;
  aspect-ratio: 9 / 16;
  background: rgba(0, 0, 0, 0.3);

  ${device.small} {
    height: 80vh;
  }
`

export const VerticalPlayerViewContainer = styled.div<IVerticalPlayerViewWrapperProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${accessibilityZIndex + 1};
  overflow: hidden;

  ${device.medium} {
    direction: rtl;
    padding: 3px;
  }

  .swiper-container {
    height: 100%; /* Full screen swiper */
    overflow: auto; /* Allow scrolling inside modal */
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100dvh;

    ${device.medium} {
      height: 100%;
    }
  }

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }

  button {
    position: absolute;
    top: 20px;
    right: 20px;
    background-color: #ff3b30;
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 16px;
  }
`
